export default "/static/images/dakkapel_1.png?fae179a543cd932bfe896b55faac81b8";